<!---图片验证码-->
<template>
  <Layer :layerName="layerName" :visible="orderUI.showImageVCode" maskDirection="Middle" style="z-index: 9999">
    <div class="dlrLayer-middle">
      <div class="mailmSucc">
        <i class="mailmSucc-close" id="Yzm" @click="close"></i>
        <div class="mailmSucc-second">
          <h4 class="secondName">请输入验证码</h4>
          <div class="secondForm">
            <ul class="dlrFormul">
              <li>
                <div class="dlrFormul-card">
                  <p class="dlrFormul-card-text">
                    <input type="text" class="dlrFormul-inpText" placeholder="请输入验证码" v-model="imgCode" />
                  </p>
                </div>
                <p class="dlrFormul-other">
                  <span class="dlrFormul-other-yzmpic" @click="refreshImgCode">
                    {{ orderUI.imgCodeUrl }}
                    <img v-if="orderUI.imgCodeUrl" :src="orderUI.imgCodeUrl" alt="图片验证码" />
                  </span>
                  <i @click="refreshImgCode" class="dlrFormul-icon iconRefresh"></i>
                </p>
              </li>
            </ul>
          </div>
          <div class="mailbForm-link">
            <span class="linkBtn" @click="confirm">
              <em>
                <b class="btnName">确认</b>
              </em>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="dlrLayer-mask" @click="close"></div>
  </Layer>
</template>
<script>
import { defineComponent, ref } from 'vue-demi';
import layerManager from '../../services/layer.manager';
import * as layerNames from '../../services/layerName';
import Layer from '../Layer.vue';
export default defineComponent({
  components: {
    Layer,
  },
  props: {
    orderUI: {
      type: Object,
      default: function () {
        return {};
      }
    },
    refreshImgCode: {
      type: Function,
      default: (imgCode) => {
        console.log(imgCode);
      },
    },
    closeImgCode: {
      type: Function,
      default: () => {
        console.log();
      },
    },
    confirmImgCode: {
      type: Function,
      default: (imgCode) => {
        console.log(imgCode);
      }
    },
  },
  setup (props) {
    const imgCode = ref('');
    function confirm () {
      if (!imgCode.value) {
        layerManager.toast({ propsData: { message: '请输入验证码！' } }, 2000);
        return;
      }
      props.confirmImgCode(imgCode.value);
    }
    function refresh () {
      props.refreshImgCode();
    }
    function close () {
      props.closeImgCode();
    }
    return {
      imgCode,
      close,
      confirm,
      refresh,
      layerName: layerNames.RED_PACKET_IMG_CODE_LAYER,
    };
  },
});
</script>
<style lang="scss">
//==========
//> 表单
.dlrFormul {
  padding: 0 0;
  box-sizing: border-box;
  color: #111e36;
  font-size: ptrd(32);

  //==========
  //>> 表单内重置input

  //>> input text 样式
  &-inpText {
    width: 100%;
    height: ptrd(50);
    line-height: ptrd(50);
    box-sizing: border-box;
    font-size: ptrd(32);

    &::-webkit-input-placeholder {
      color: #c5cad4;
    }
  }


  //>> ICON 样式
  &-icon {
    display: inline-block;
    vertical-align: top;
    width: ptrd(50);
    height: ptrd(50);

    //>>> 刷新
    &.iconRefresh {
      background: url('data:image/png;base64,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') no-repeat center center;
      background-size: ptrd(50);
    }

  }

  li {
    position: relative;
    display: flex;
    flex-direction: row;
    min-height: ptrd(100);
    padding: ptrd(25) 0;
    line-height: ptrd(50);
    border-bottom: 1px solid #f8f9fc;
    box-sizing: border-box;
  }


  //>> 中间区域
  &-card {
    flex: 1;
    width: 1%;

    //>>> 文字层 一行截断
    &-text {
      color: #c5cad4;
      @extend %ellipsis-basic;
    }
  }

  //>> 右侧区域 放置icon等其它
  &-other {
    position: relative;
    z-index: 0;
    font-size: 0;

    .dlrFormul-icon {
      margin: 0 0 0 ptrd(6);
    }

    //>>> 图片验证码
    &-yzmpic {
      display: inline-block;
      vertical-align: middle;
      width: ptrd(164);
      height: ptrd(60);
      margin: ptrd(-5) 0 ptrd(-5) 0;
      overflow: hidden;
      border-radius: ptrd(8);
      @extend %athm-holdimg-white;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}

//==========
//> 中间弹层 询价成功
.mailmSucc {
  position: relative;
  width: ptrd(600);
  padding: ptrd(50) ptrd(30) ptrd(40) ptrd(30);
  border-radius: ptrd(20);
  background: rgba(23, 10, 97, 0.92);
  box-sizing: border-box;
  max-height: 80vh;
  overflow: hidden;
  overflow-y: auto;

  //>> 关闭按钮
  &-close {
    position: absolute;
    z-index: 10;
    top: 0;
    right: 0;
    width: ptrd(80);
    height: ptrd(80);
    background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAA6klEQVRIS72VYRLBMBCFLafR3zU4Am5hHMu4BY6A0d91GtZsBhOy2by02v7qTJL3Zfe9JDTo+CPRZ2a6VLeF/E/L8ZGIuAlX03GA87Ve3vmxl38i2s3LYpMLEfFTVW+ZeS06IxquZpPiEACaQH7FA4A2Aa0ktdZV8PbBLxGpJCXuNHwzkQW5G/oCoJXkbCQApCAyntNKFWBBXmMuiohPUUAM4nuGJM0EWBBEPEiRdj1ohiKt+bTQunNi4mj/zQpiUfyLyVbOW8cUOUTIHNWDnIXo3H4uO3Q3aIz9M9LPg9P5k9n5o2+d5rZjT4UnqCif3BKkAAAAAElFTkSuQmCC') no-repeat center center;
    background-size: ptrd(24);
  }



  &-second {
    text-align: center;
  }



  .secondName {
    height: ptrd(44);
    line-height: ptrd(44);
    font-size: ptrd(34);
    font-weight: bold;
    margin-bottom: ptrd(20px);
  }

  .dlrFormul li {
    background: #fff;
    border-radius: 4px;
    border-bottom: 0;
    min-height: ptrd(80px);
    padding: ptrd(15px) ptrd(30px);
  }

  .mailbForm-link {
    padding: ptrd(30px) 0 0;
    text-align: center;

    .linkBtn {
      display: block;
      @include gradient-horizontal(#4c88ff, #206cfe);
      border-radius: ptrd(8px);
      color: #fff;
    }

    .linkBtn em {
      display: flex;
      line-height: ptrd(100);
      font-size: ptrd(32);
      align-items: center;
      justify-content: center;
      flex-direction: column;
      height: ptrd(80px);

      b {
        display: block;
        width: 100%;
      }
    }
  }
}
</style>
